//Stateler çekilip return edilecek

export const stockList = (state) => {
  return state.stocks
}

export const stock = (state) => {
  return state.stock
}

export const movementsList = (state) => {
  return state.movements
}

export const movementTypes = (state) => {
  return state.movementTypes
}

export const getMovementPageInfo = (state) => {
  return state.movementPageInfo
}

export const getStockPageInfo = (state) => {
  return state.stockPageInfo
}

export const getStockLoading = (state) => {
  return state.loading
}

export const getStockStatus = (state) => {
  return state.stockStatus
}

export const getStockMovementDetail = (state) => {
  return state.stockMovement
}
export const faultSupportsList = (state) => {
  return state.faultSupports
}

export const faultSupport = (state) => {
  return state.faultSupport
}

export const faultStatuses = (state) => {
  return state.faultStatuses
}

export const faultSupportImages = (state) => {
  return state.faultSupportImages
}

export const pieces = (state) => {
  return state.pieces
}

export const faultSupportPieces = (state) => {
  return state.faultSupportPieces
}

export const faultSupportResults = (state) => {
  return state.faultSupportResults
}

export const getFaultSupportPageInfo = (state) => {
  return state.faultSupportPageInfo
}

export const faultTracking = (state) => {
  return state.faultTracking
}

export const getUntrackInfo = (state) => {
  return state.untrackInfo
}



// WEBPACK FOOTER //
// ./src/store/modules/Stock/Getters.js